<template>
  <!-- 最新动态 -->
  <div class="latest-news">
    
    <span class="btn-more sk-text c_pointer" @click="handleClickOpen('/user-center/home',['a_homeClickLatestNews','','more'])">
      {{$xinI18n('更多','Comment-handleValidate-gengduo')}}
      <XinIcon xin-type="arrow-right-s-line" />
    </span>

    <XinLoading v-if="loading" />

    <XinEmptyPage v-else-if="isEmpty" :title-content="$xinI18n('暂无数据','Common-zanwushuju')" />

    <div v-else class="news-content">
      <transition-group tag="ul" class="banner-list sk--hover-light9-only-bg sk--hover-border" name="list">
        <li class="c_pointer" v-for="(item,index) in bannerList" :key="item.id" v-show="index===currentIndex" @click="handleClickOpen(`/user-center/live/detail?id=${item.id}`,['a_homeClickLatestNews','','video'])" @mouseenter="slideshowStop" @mouseleave="slideshowGo">
          <div class="right">
            <img :src="item.coverImage">
          </div>
          <div class="left">
            <p class="title ellipsis">{{item.title}}</p>
            <p class="desc ellipsis">{{item.summary}}</p>
          </div>
        </li>
      </transition-group>
      <ul class="news-list">
        <li v-for="item in newsList" :key="item.id" class="c_pointer" @click="handleClickOpen(`/user-center/update-log/detail?id=${item.id}`,['a_homeClickLatestNews','','notice'])">
          <p class="title ellipsis">{{item.title}}</p>
          <p class="date m_l8">{{item.publishTime | momentTime}}</p>
        </li>
        <div 
          v-if="showAllBtn" 
          class="all-news-btn c_pointer sk--hover-light9-only-bg sk--hover-text"
          @click="handleClickOpen('/user-center/update-log/list',['a_homeClickLatestNews','','allUpdateLog'])"
        >全部升级日志</div>
      </ul>
    </div>

  </div>
</template>

<script lang="ts">
import { Vue, Component } from "vue-property-decorator";
import moment from "moment"
import { XinLoading, XinIcon, XinEmptyPage } from "@xin/xin-ui"

@Component({
  name: "LatestNews",
  components:{
    XinLoading, 
    XinIcon, 
    XinEmptyPage,
  },
  filters:{
    momentTime:(val:string)=>{
      return moment(val,'YYYY-MM-DD HH:mm:ss').format('MM/DD HH:mm')
    }
  }
})
export default class LatestNews extends Vue {
  loading = true
  currentIndex = 0
  timer:any = null
  bannerList = []
  newsList = []
  showAllBtn = false

  get isEmpty(){
    return !this.bannerList.length && !this.newsList.length 
  }

  async created(){
    this.getNewsList()
    this.getVideoList()
    this.slideTimeShow()
  }

  getNewsList(){
    //@ts-ignore
    return this.$http({
      url: '/customer-center/service/uc/ajax-product-documentation-list?type=2&pageNo=1&pageSize=6&module=all',
      method: "get"
    }).then((res:any) => {
      if(res.data.status){
        this.newsList = res.data.data.records || []
        this.showAllBtn = res.data.data.total > 6
      }
    }).catch((err: any) => {
      this.loading = false
    });
  }

  getVideoList(){
    //@ts-ignore
    return this.$http({
      url: '/customer-center/service/uc/ajax-product-video-list?pageSize=5&pageNo=1&modules=all&type=1&companyRecommendStatus=1',
      method: "get"
    }).then((res:any) => {
      if(res.data.status){
        this.bannerList = res.data.data.records || []
        this.loading = false
      }
    }).catch((err: any) => {
      this.loading = false
    });
  }

  handleClickOpen(link:string,trackerParams?:any[]){
    const userCenterSwitch = window.deployFunctionSwitch?.userCenter
    if(userCenterSwitch !== '1') return this.$message.error("功能未开放")
    if(trackerParams){
      //@ts-ignore
      this.XrxsTracker.$track(...trackerParams)
    }
    window.open(link)
  }

  slideTimeShow(){
    this.$nextTick(() => {
      this.timer = setInterval(() => {
        this.autoPlay()
      }, 3000)
    })
  }
  slideshowGo() {
    this.timer = setInterval(() => {
      this.autoPlay()
    }, 3000)
  }
  slideshowStop() {
    clearInterval(this.timer)
    this.timer = null
  }
  autoPlay() {
    this.currentIndex++
    if (this.currentIndex > this.bannerList.length - 1) {
      this.currentIndex = 0
    }
  }

}
</script>

<style lang="scss" scoped>
@import "./index.scss";
</style>
